'use client';

import { useRef, useEffect, useMemo } from 'react';
import { useAppStore } from '@castlery/shared-redux-store';
import { EVENT_COMMON_PAGE_VIEW } from '@castlery/modules-tracking-services';
import { WEB_PAGE_NAMES } from '@castlery/config';
import { DYResourceTag } from '@castlery/modules-dy-components';
import { DYPageTypes } from '@castlery/modules-dy-domain';

export function PlpSalePageClient({ breadcrumb, uuid }: { breadcrumb: string; uuid: string }) {
  const initializedRef = useRef(false);
  const store = useAppStore();

  const dyCategoryContext = useMemo(() => {
    return {
      type: DYPageTypes.CATEGORY,
      data: [breadcrumb],
    };
  }, [breadcrumb]);

  useEffect(() => {
    if (!initializedRef.current) {
      store.dispatch(
        EVENT_COMMON_PAGE_VIEW({
          pageName: WEB_PAGE_NAMES.SALE_PAGE,
          customPageProduct: uuid,
        })
      );
      initializedRef.current = true;
    }
  }, [uuid]);

  return <DYResourceTag recommendationContext={dyCategoryContext} />;
}
